import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useMemo, useState } from 'react';
import GlobalStyle from '../components/GlobalStyle';
import { getStore } from '../utils/store/helper';
var CustomGlobalStyle = function CustomGlobalStyle() {
  var store = useMemo(function () {
    return getStore();
  }, []);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    styles = _useState2[0],
    setStyles = _useState2[1];
  useEffect(function () {
    var unsubscribe = store.subscribe(function (state) {
      setStyles(_toConsumableArray(state.customStyles || []));
    });
    return function () {
      return unsubscribe();
    };
  }, [store]);
  return /*#__PURE__*/React.createElement(GlobalStyle, {
    id: "hzero-ued-custom-global-style",
    css: styles
  });
};
export default CustomGlobalStyle;